import { render, staticRenderFns } from "./ImageChooser.vue?vue&type=template&id=412b8f2f&"
import script from "./ImageChooser.vue?vue&type=script&lang=js&"
export * from "./ImageChooser.vue?vue&type=script&lang=js&"
import style0 from "./ImageChooser.vue?vue&type=style&index=0&id=412b8f2f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports